import './style.css'
import * as THREE from 'three'

const SUPABASE_URL = 'https://yupslyktelravupuxksk.supabase.co'
const SUPABASE_KEY = 'sb_publishable_HTjx7Q-Cjcg6XPgUOekvcA_ovVR-pVN'

let sb = null

async function sbInit() {
    if (window.supabase) {
        sb = window.supabase.createClient(SUPABASE_URL, SUPABASE_KEY)
        return true
    }
    console.warn('Supabase SDK not loaded — check index.html CDN script')
    return false
}

async function sbGetRoom(code) {
    const { data, error } = await sb.from('rooms').select('*').eq('code', code).single()
    if (error && error.code !== 'PGRST116') throw error
    return data
}
async function sbGetPlayers(code) {
    const { data, error } = await sb.from('room_players').select('*')
        .eq('room_code', code).order('joined_at')
    if (error) throw error
    return data || []
}
async function sbCreateRoom(code) {
    const { error } = await sb.from('rooms').insert({ code, started: false, map_level: 'map1', all_start: false })
    if (error) throw error
}
async function sbAddPlayer(id, roomCode, name, hex, isHostFlag) {
    const { error } = await sb.from('room_players')
        .insert({ id, room_code: roomCode, name, hex, is_host: isHostFlag })
    if (error) throw error
}
async function sbRemovePlayer(id) {
    const { error } = await sb.from('room_players').delete().eq('id', id)
    if (error) throw error
}
async function sbDeleteRoom(code) {
    const { error } = await sb.from('rooms').delete().eq('code', code)
    if (error) throw error
}
async function sbStartRoom(code) {
    const { error } = await sb.from('rooms').update({ started: true }).eq('code', code)
    if (error) throw error
}

function sbSubscribeRoom(code, onPlayersChange, onRoomStarted, onAllStart) {
    const channel = sb.channel(`room-${code}`)
    channel
        .on('postgres_changes', {
            event: '*', schema: 'public', table: 'room_players',
            filter: `room_code=eq.${code}`
        }, () => onPlayersChange())
        .on('postgres_changes', {
            event: 'UPDATE', schema: 'public', table: 'rooms',
            filter: `code=eq.${code}`
        }, payload => {
            if (payload.new?.started && !payload.old?.started) onRoomStarted()
            if (payload.new?.all_start && !payload.old?.all_start) {
                if (typeof onAllStart === 'function') onAllStart(payload.new.map_level)
            }
        })
        .subscribe()
    return channel
}

let gameChannel = null
const charSelections = {}

function openGameChannel(code, myId, onRemoteState, onRemoteCharPick) {
    if (gameChannel) return
    gameChannel = sb.channel(`game-${code}`, {
        config: { broadcast: { self: false } }
    })
    gameChannel
        .on('broadcast', { event: 'state' }, ({ payload }) => {
            if (payload.id !== myId) onRemoteState(payload)
        })
        .on('broadcast', { event: 'chat' }, ({ payload }) => {
            if (payload.id !== myId) {
                appendChatMsg('remote', { name: payload.name, hex: payload.hex }, payload.text)
            }
        })
        .on('broadcast', { event: 'char' }, ({ payload }) => {
            if (payload.id !== myId) {
                onRemoteCharPick(payload)
                if (!gameRunning) rebuildCharGridLive()
            }
        })
        .subscribe((status) => {
            if (status === 'SUBSCRIBED' && selectedChar !== null) broadcastCharPick()
        })
    return gameChannel
}

function startGameSync(code, myId, onRemoteState) {
    openGameChannel(code, myId, onRemoteState, onRemoteCharPickHandler)
}

function broadcastMyState(state) {
    if (!gameChannel) return
    gameChannel.send({ type: 'broadcast', event: 'state', payload: state })
}

function broadcastCharPick() {
    if (!gameChannel || !myPlayerId || selectedChar === null) return
    gameChannel.send({
        type: 'broadcast', event: 'char',
        payload: { id: myPlayerId, name: playerNameStr, hex: CHARS[selectedChar].hex }
    })
}

function onRemoteCharPickHandler(payload) {
    charSelections[payload.id] = { hex: payload.hex, name: payload.name }
    const rp = roomPlayers.find(p => p.id === payload.id)
    if (rp) rp.hex = payload.hex
    if (gameRunning && remotePlayers[payload.id]) updateRemotePlayerColor(payload.id, payload.hex)
}

function rebuildCharGridLive() {
    const takenHex = Object.entries(charSelections)
        .filter(([id]) => id !== myPlayerId)
        .map(([, v]) => v.hex)
    document.querySelectorAll('.charCard').forEach((card, i) => {
        const ch = CHARS[i]
        const taken = takenHex.includes(ch.hex) && !(selectedChar === i)
        card.className = 'charCard' + (taken ? ' taken' : '') + (selectedChar === i ? ' sel' : '')
        const swatch = card.querySelector('.charSwatch')
        const label  = card.querySelector('.charName')
        if (swatch) swatch.style.opacity = taken ? '0.35' : '1'
        if (label)  label.textContent = ch.name + (taken ? ' (taken)' : '')
        if (!taken) {
            card.onclick = () => {
                document.querySelectorAll('.charCard').forEach(c => c.classList.remove('sel'))
                card.classList.add('sel'); selectedChar = i
                const b = document.getElementById('btnStart')
                if (b) { b.disabled = false; b.className = 'menuBtn success' }
                if (currentMode === 'multi') broadcastCharPick()
            }
        } else { card.onclick = null }
    })
}

function stopGameSync() {
    if (gameChannel && sb) { sb.removeChannel(gameChannel); gameChannel = null }
}

const CHARS = [
    { name:'Red Rider',    color:0xff3333, hex:'#ff3333' },
    { name:'Yellow Racer', color:0xffdd00, hex:'#ffdd00' },
    { name:'Green Rush',   color:0x44ff44, hex:'#44ff44' },
    { name:'Cyan Dash',    color:0x00ccff, hex:'#00ccff' },
    { name:'Purple Skate', color:0xdd44ff, hex:'#dd44ff' },
    { name:'Orange Bolt',  color:0xff9900, hex:'#ff9900' },
]

let selectedChar  = null
let currentMode   = 'single'
let lastMode      = 'single'
let playerNameStr = 'Player'
let roomCode      = null
let myPlayerId    = null
let isHost        = false
let realtimeChan  = null
let roomPlayers   = []
let remotePlayers = {}

let pendingMapId = 'map1'
let smoothCamY   = null

let lastBroadcast = 0
const BROADCAST_INTERVAL = 50

const remoteLastSeen = {}
const DISCONNECT_TIMEOUT = 4000

const joy = { x:0, y:0, active:false, jumping:false, braking:false }
let joyTouchId = null

const canvas = document.querySelector('canvas.webgl')
let scene, camera, renderer, clock
let trackPieces = [], spinnerList = [], staticObstacles = []
let allPlayers = [], userPlayer = null
let finishLineZ = 0
let gameRunning = false, gamePaused = false, raceOver = false
let finishedCount = 0, finishResults = []
let animId = null
let mapTickCallback = null

const keys = {}
window.addEventListener('keydown', e => { keys[e.code] = true })
window.addEventListener('keyup',   e => { keys[e.code] = false })

const GRAVITY = 60, BRAKE_F = 0.35, SLIDE_X = 0.94
const ROLL_Z  = 0.94, AIR_D  = 0.98, PLAYER_R = 2.2

let trkMat, startMat

const genId   = () => Math.random().toString(36).substring(2, 12)
const genCode = () => Math.random().toString(36).substring(2, 8).toUpperCase()
const esc     = s  => String(s).replace(/[&<>"']/g, c =>
    ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]))

// ── MUSIC HELPERS ──────────────────────────────────────────────────────────
// We keep a flag so we only cross-fade once when the game actually begins
let _gameMusicStarted = false

function switchToMenuMusic() {
    const bgm     = document.getElementById('bgMusic')
    const menuBgm = document.getElementById('menuMusic')
    if (!bgm || !menuBgm) return
    bgm.pause()
    _gameMusicStarted = false
    if (menuBgm.paused) {
        menuBgm.currentTime = menuBgm.currentTime || 0
        try { menuBgm.play().catch(() => {}) } catch(e) {}
    }
}

function switchToGameMusic() {
    if (_gameMusicStarted) return          // already running — don't restart
    _gameMusicStarted = true
    const bgm     = document.getElementById('bgMusic')
    const menuBgm = document.getElementById('menuMusic')
    if (!bgm || !menuBgm) return
    menuBgm.pause()
    bgm.currentTime = 0
    bgm.loop = true
    try { bgm.play().catch(() => {}) } catch(e) {}
}

// ── SCREEN MANAGEMENT ──────────────────────────────────────────────────────
// These screens must NOT trigger a music change — menu music keeps playing
const MUSIC_NEUTRAL_SCREENS = [
    'playerSelect', 'pauseMenu', 'createRoom', 'waitingRoom', 'joinRoom', 'multiMenu'
]

function showScreen(id) {
    document.querySelectorAll('.screen').forEach(s => {
        s.classList.add('hidden')
        s.style.display = 'none'
        s.style.visibility = 'hidden'
        s.style.pointerEvents = 'none'
        s.style.zIndex = '-1'
    })
    const el = document.getElementById(id)
    if (el) {
        el.classList.remove('hidden')
        el.style.display = 'flex'
        el.style.visibility = 'visible'
        el.style.pointerEvents = 'auto'
        el.style.zIndex = '20'
    }
    // Only switch music for true "back to menu" screens
    if (!MUSIC_NEUTRAL_SCREENS.includes(id)) {
        switchToMenuMusic()
    }
}

function hideAllScreens() {
    // Pause skate sfx when leaving game
    const skateSfx = document.getElementById('skateSfx')
    if (skateSfx) skateSfx.pause()

    document.querySelectorAll('.screen').forEach(s => {
        s.classList.add('hidden')
        s.style.display = 'none'
        s.style.visibility = 'hidden'
        s.style.pointerEvents = 'none'
        s.style.zIndex = '-1'
    })
}

function setErr(msg) { document.getElementById('joinError').textContent = msg }

function stopRealtime() {
    if (realtimeChan && sb) { sb.removeChannel(realtimeChan); realtimeChan = null }
}

async function leaveRoom() {
    stopRealtime(); stopGameSync()
    if (sb && roomCode && myPlayerId) {
        try { await sbRemovePlayer(myPlayerId); if (isHost) await sbDeleteRoom(roomCode) } catch {}
    }
    roomCode = null; myPlayerId = null; isHost = false; roomPlayers = []
    Object.keys(charSelections).forEach(k => delete charSelections[k])
}

function renderRoomPlayers(players, hostView) {
    const count = players.length
    const chips = players.map(p =>
        `<div class="waitChip">
            <div class="waitDot" style="background:${p.hex}"></div>
            ${esc(p.name)}${p.is_host ? ' 👑' : ''}
        </div>`
    ).join('')
    if (hostView) {
        document.getElementById('waitCount').textContent = count
        document.getElementById('waitList').innerHTML = chips
        const hint = document.getElementById('waitHint')
        const btn  = document.getElementById('btnStartRoom')
        if (count < 2) {
            btn.disabled = true; btn.className = 'menuBtn success disabled'
            hint.textContent = '⏳ Waiting for at least 1 more player…'; hint.style.color = '#ff9900'
        } else if (count <= 6) {
            btn.disabled = false; btn.className = 'menuBtn success'
            hint.textContent = `✅ ${count} players ready — you can start!`; hint.style.color = '#44ffaa'
        } else {
            btn.disabled = true; btn.className = 'menuBtn success disabled'
            hint.textContent = '🚫 Room full (max 6 players)'; hint.style.color = '#ff6644'
        }
    } else {
        document.getElementById('waitRoomPlayers').innerHTML = chips
    }
}

// ── BUTTON WIRING ──────────────────────────────────────────────────────────
document.getElementById('btnPlay').onclick       = () => showScreen('modeSelect')
document.getElementById('btnModeBack').onclick    = () => showScreen('mainMenu')
document.getElementById('btnMultiBack').onclick   = () => showScreen('modeSelect')
document.getElementById('btnResume').onclick      = doResume
document.getElementById('btnPauseMenu').onclick   = returnToMenu
document.getElementById('finishMenuBtn').onclick   = returnToMenu
document.getElementById('finishAgainBtn').onclick  = playAgain

document.getElementById('btnSingle').onclick = () => {
    currentMode = 'single'; buildCharGrid()
    const mapBox = document.getElementById('mapSelectBox')
    if (mapBox) mapBox.style.display = 'block'
    document.getElementById('btnSelectBack').onclick = () => showScreen('modeSelect')
    showScreen('playerSelect')
}
document.getElementById('btnMulti').onclick = () => showScreen('multiMenu')

document.getElementById('btnJoin').onclick = () => {
    setErr(''); document.getElementById('joinName').value = ''; document.getElementById('joinCode').value = ''
    showScreen('joinRoom')
}
document.getElementById('btnJoinBack').onclick = () => showScreen('multiMenu')

document.getElementById('btnDoJoin').onclick = async () => {
    const code = document.getElementById('joinCode').value.trim().toUpperCase()
    const name = document.getElementById('joinName').value.trim() || 'Player'
    setErr('')
    if (!sb)               { setErr('❌ Supabase not connected.'); return }
    if (code.length !== 6) { setErr('Code must be exactly 6 characters!'); return }
    const btn = document.getElementById('btnDoJoin')
    btn.textContent = '⏳ Joining…'; btn.disabled = true
    try {
        const room = await sbGetRoom(code)
        if (!room)        { setErr('❌ Room not found.'); return }
        if (room.started) { setErr('🚫 Game already started!'); return }
        const existing = await sbGetPlayers(code)
        if (existing.length >= 6) { setErr('🚫 Room is full!'); return }
        const takenHex = existing.map(p => p.hex)
        const freeChar = CHARS.find(c => !takenHex.includes(c.hex)) || CHARS[0]
        myPlayerId = genId(); roomCode = code; isHost = false; playerNameStr = name
        await sbAddPlayer(myPlayerId, code, name, freeChar.hex, false)

        stopRealtime()
        realtimeChan = sbSubscribeRoom(code,
            async () => {
                const players = await sbGetPlayers(code)
                roomPlayers = players
                renderRoomPlayers(players, false)
            },
            async () => {
                currentMode = 'multi'
                const players = await sbGetPlayers(code)
                roomPlayers = players
                openGameChannel(code, myPlayerId, onRemotePlayerState, onRemoteCharPickHandler)
                const mapBox = document.getElementById('mapSelectBox')
                if (mapBox) mapBox.style.display = 'none'
                buildCharGrid()
                document.getElementById('pName').value = playerNameStr
                document.getElementById('btnSelectBack').onclick = async () => {
                    await leaveRoom(); showScreen('multiMenu')
                }
                showScreen('playerSelect')
            },
            (map_level) => {
                if (gameRunning) return
                pendingMapId = map_level || 'map1'
                _finalizeLaunch()
            }
        )

        roomPlayers = existing.concat([{ id: myPlayerId, name, hex: freeChar.hex, is_host: false }])
        document.getElementById('waitRoomCode').textContent = code
        renderRoomPlayers(roomPlayers, false)
        showScreen('waitingRoom')

    } catch (e) {
        console.error(e); setErr('❌ Network error.')
    } finally {
        btn.textContent = '🚪 Join'; btn.disabled = false
    }
}

document.getElementById('btnCreate').onclick = async () => {
    if (!sb) { alert('❌ Add your Supabase credentials first.'); return }
    await leaveRoom()
    const code = genCode(), pid = genId()
    const hostNameVal = document.getElementById('hostNameInput')?.value || document.getElementById('pName')?.value || ''
    const hostName = hostNameVal.trim() || 'Host'
    const hostChar = CHARS[0]
    isHost = true; myPlayerId = pid; roomCode = code
    try {
        await sbCreateRoom(code)
        await sbAddPlayer(pid, code, hostName, hostChar.hex, true)
    } catch (e) {
        console.error(e); alert('❌ Could not create room.'); await leaveRoom(); return
    }
    document.getElementById('roomCode').textContent = code
    roomPlayers = [{ id: pid, name: hostName, hex: hostChar.hex, is_host: true }]
    renderRoomPlayers(roomPlayers, true)
    stopRealtime()
    realtimeChan = sbSubscribeRoom(code,
        async () => {
            const players = await sbGetPlayers(code)
            roomPlayers = players
            renderRoomPlayers(players, true)
        },
        () => {}, () => {}
    )
    showScreen('createRoom')
}

document.getElementById('btnRoomBack').onclick     = async () => { await leaveRoom(); showScreen('multiMenu') }
document.getElementById('btnWaitRoomBack').onclick = async () => { await leaveRoom(); showScreen('multiMenu') }

document.getElementById('btnStartRoom').onclick = async () => {
    if (roomPlayers.length < 2) return
    try { await sbStartRoom(roomCode) } catch (e) { console.error(e); alert('Failed to start.'); return }
    currentMode = 'multi'
    openGameChannel(roomCode, myPlayerId, onRemotePlayerState, onRemoteCharPickHandler)
    const mapBox = document.getElementById('mapSelectBox')
    if (mapBox) mapBox.style.display = 'block'
    buildCharGrid()
    document.getElementById('pName').value = playerNameStr
    document.getElementById('btnSelectBack').onclick = async () => { await leaveRoom(); showScreen('multiMenu') }
    showScreen('playerSelect')
}

document.getElementById('btnStart').onclick = launchGame

document.addEventListener('keydown', e => {
    if (e.key === 'Escape' && gameRunning) gamePaused ? doResume() : doPause()
})

function buildCharGrid() {
    const grid = document.getElementById('charGrid')
    grid.innerHTML = ''; selectedChar = null
    const btn = document.getElementById('btnStart')
    const waitMsg = document.getElementById('charWaitMsg')
    const takenHex = currentMode === 'multi'
        ? Object.entries(charSelections).filter(([id]) => id !== myPlayerId).map(([, v]) => v.hex)
        : []
    CHARS.forEach((ch, i) => {
        const taken = takenHex.includes(ch.hex)
        const card = document.createElement('div')
        card.className = 'charCard' + (taken ? ' taken' : '')
        card.innerHTML = `
            <div class="charSwatch" style="background:${ch.hex};box-shadow:0 4px 16px ${ch.hex}55;${taken?'opacity:.35':''}"></div>
            <div class="charName">${ch.name}${taken?' (taken)':''}</div>`
        if (!taken) {
            card.onclick = () => {
                document.querySelectorAll('.charCard').forEach(c => c.classList.remove('sel'))
                card.classList.add('sel'); selectedChar = i
                if (currentMode === 'multi') broadcastCharPick()
                if (btn) { btn.disabled = false; btn.className = 'menuBtn success' }
            }
        }
        grid.appendChild(card)
    })
    if (currentMode === 'multi') {
        if (btn) {
            btn.style.display = ''
            btn.disabled = true
            btn.className = 'menuBtn success disabled'
            btn.textContent = isHost ? '▶ Start Game' : '✅ Ready!'
        }
        if (waitMsg) waitMsg.style.display = 'none'
    } else {
        if (btn) {
            btn.style.display = ''
            btn.disabled = true
            btn.className = 'menuBtn success disabled'
            btn.textContent = '▶ Start Game'
        }
        if (waitMsg) waitMsg.style.display = 'none'
    }
}

async function launchGame() {
    if (selectedChar === null) return

    if (currentMode === 'multi' && !isHost) {
        const btn = document.getElementById('btnStart')
        if (btn) {
            btn.disabled = true
            btn.className = 'menuBtn success disabled'
            btn.textContent = '⏳ Waiting for host…'
        }
        return
    }

    if (currentMode === 'multi' && isHost) {
        const mapEl = document.getElementById('mapSelect')
        pendingMapId = mapEl ? mapEl.value : 'map1'
        try {
            const { error } = await sb.from('rooms')
                .update({ map_level: pendingMapId, all_start: true })
                .eq('code', roomCode)
            if (error) throw error
        } catch (e) {
            console.error(e); alert('Failed to start game. Please try again.'); return
        }
        _finalizeLaunch()
        return
    }

    // Single player
    const mapEl = document.getElementById('mapSelect')
    pendingMapId = mapEl ? mapEl.value : 'map1'
    _finalizeLaunch()
}

function _finalizeLaunch() {
    if (gameRunning) return

    if (selectedChar === null) {
        selectedChar = CHARS.findIndex(ch => {
            const takenHex = Object.entries(charSelections)
                .filter(([id]) => id !== myPlayerId).map(([,v]) => v.hex)
            return !takenHex.includes(ch.hex)
        })
        if (selectedChar === -1) selectedChar = 0
    }

    playerNameStr = (document.getElementById('pName').value || '').trim() || playerNameStr || 'Player'
    document.getElementById('hudName').textContent = playerNameStr
    lastMode = currentMode

    // Hide all screens cleanly - use !important inline styles for mobile
    document.querySelectorAll('.screen').forEach(s => {
        s.classList.add('hidden')
        s.style.display = 'none !important'
        s.style.visibility = 'hidden !important'
        s.style.pointerEvents = 'none !important'
        s.style.zIndex = '-100'
    })

    // Reset pauseMenu so it works during gameplay
    const pmReset = document.getElementById('pauseMenu')
    if (pmReset) {
        pmReset.style.removeProperty('display')
        pmReset.style.removeProperty('visibility')
        pmReset.style.removeProperty('pointer-events')
        pmReset.style.removeProperty('z-index')
        pmReset.classList.add('hidden')
        pmReset.querySelectorAll('.card').forEach(c => {
            c.style.removeProperty('display')
            c.style.removeProperty('visibility')
        })
    }

    // Ensure canvas is visible on top of all screens
    canvas.style.position = 'fixed'
    canvas.style.zIndex = '1000'

    stopRealtime()

    if (currentMode === 'multi') {
        const myRoomPlayer = roomPlayers.find(p => p.id === myPlayerId)
        if (myRoomPlayer) myRoomPlayer.hex = CHARS[selectedChar].hex
        startGame(selectedChar, playerNameStr, 0, 'multi', pendingMapId)
    } else {
        startGame(selectedChar, playerNameStr, 4, 'single', pendingMapId)
    }
}

function doPause() {
    gamePaused = true
    // Pause skating sound when paused
    const skateSfx = document.getElementById('skateSfx')
    if (skateSfx) skateSfx.pause()
    const pm = document.getElementById('pauseMenu')
    pm.style.removeProperty('display')
    pm.style.removeProperty('visibility')
    pm.style.removeProperty('pointer-events')
    pm.style.removeProperty('z-index')
    pm.classList.remove('hidden')
    pm.querySelectorAll('.card').forEach(c => {
        c.style.removeProperty('display')
        c.style.removeProperty('visibility')
    })
}
function doResume() {
    gamePaused = false
    const pm = document.getElementById('pauseMenu')
    pm.classList.add('hidden')
    pm.style.removeProperty('display')
    pm.style.removeProperty('visibility')
    pm.style.removeProperty('pointer-events')
    pm.style.removeProperty('z-index')
}

function returnToMenu() {
    // Stop all game audio
    const skateSfx = document.getElementById('skateSfx')
    if (skateSfx) skateSfx.pause()

    stopRealtime(); stopGameSync(); cleanupGame()
    hideChatUI()
    canvas.style.display = 'none'
    document.getElementById('hud').style.display           = 'none'
    document.getElementById('mobileControls').style.display = 'none'
    document.getElementById('finishOverlay').style.display  = 'none'
    document.getElementById('pauseMenu').classList.add('hidden')
    // Reset all screen + card inline styles so showScreen works cleanly
    document.querySelectorAll('.screen, .card').forEach(el => {
        el.style.removeProperty('display')
        el.style.removeProperty('visibility')
        el.style.removeProperty('pointer-events')
        el.style.removeProperty('z-index')
    })
    showScreen('mainMenu')  // This calls switchToMenuMusic() → restarts menu music
}

function playAgain() {
    document.getElementById('finishOverlay').style.display = 'none'
    returnToMenu()
    setTimeout(() => {
        currentMode = lastMode
        buildCharGrid()
        const mapBox = document.getElementById('mapSelectBox')
        if (mapBox) mapBox.style.display = currentMode === 'single' ? 'block' : 'none'
        showScreen('playerSelect')
    }, 50)
}

// ── MOBILE CONTROLS ────────────────────────────────────────────────────────
function setupMobile() {
    const zone = document.getElementById('joystickZone')
    const base = document.getElementById('joystickBase')
    const knob = base.querySelector('#joystickKnob')
    const MAX  = 42
    zone.addEventListener('touchstart', e => { e.preventDefault(); joyTouchId = e.changedTouches[0].identifier; joy.active = true }, { passive: false })
    zone.addEventListener('touchmove', e => {
        e.preventDefault()
        for (const t of e.changedTouches) {
            if (t.identifier !== joyTouchId) continue
            const r = base.getBoundingClientRect()
            let dx = t.clientX-(r.left+r.width/2), dy = t.clientY-(r.top+r.height/2)
            const d = Math.sqrt(dx*dx+dy*dy)
            if (d > MAX) { dx=dx/d*MAX; dy=dy/d*MAX }
            joy.x=dx/MAX; joy.y=dy/MAX
            knob.style.transform=`translate(calc(-50% + ${dx}px), calc(-50% + ${dy}px))`
        }
    }, { passive: false })
    const joyEnd = () => { joy.x=0;joy.y=0;joy.active=false;knob.style.transform='translate(-50%,-50%)';joyTouchId=null }
    zone.addEventListener('touchend', joyEnd, { passive: false })
    zone.addEventListener('touchcancel', joyEnd, { passive: false })
    const jmp = document.getElementById('mobJump'), brk = document.getElementById('mobBrake')
    jmp.addEventListener('touchstart', e => { e.preventDefault(); joy.jumping = true  }, { passive: false })
    jmp.addEventListener('touchend',   e => { e.preventDefault(); joy.jumping = false }, { passive: false })
    brk.addEventListener('touchstart', e => { e.preventDefault(); joy.braking = true  }, { passive: false })
    brk.addEventListener('touchend',   e => { e.preventDefault(); joy.braking = false }, { passive: false })
    const mobPause = document.getElementById('mobPause')
    if (mobPause) {
        mobPause.addEventListener('touchstart', e => {
            e.preventDefault(); if (gameRunning) gamePaused ? doResume() : doPause()
        }, { passive: false })
    }

    // ── Music Mute Button ──
    let musicMuted = false
    const muteBtn = document.getElementById('muteMusic')
    const bgm = document.getElementById('bgMusic')
    const menuBgm = document.getElementById('menuMusic')
    if (muteBtn) {
        muteBtn.addEventListener('click', () => {
            musicMuted = !musicMuted
            if (bgm) bgm.muted = musicMuted
            if (menuBgm) menuBgm.muted = musicMuted
            muteBtn.textContent = musicMuted ? '🔇' : '🔊'
        })
    }
}

// ── TRACK HELPERS ──────────────────────────────────────────────────────────
const TRACK_H = 8, HOFF = -TRACK_H / 2

function mkStraight(w, l, mat) {
    const m = new THREE.Mesh(new THREE.BoxGeometry(w, TRACK_H, l), mat || trkMat)
    m.receiveShadow = true; return m
}
function mkRing(w, R, segs = 32) {
    const g = new THREE.Group()
    const segLen = 2 * Math.PI * R / segs + 0.6
    const geo    = new THREE.BoxGeometry(w, TRACK_H, segLen)
    for (let i = 0; i < segs; i++) {
        const mid = (i / segs + 1 / segs / 2) * Math.PI * 2
        const m   = new THREE.Mesh(geo, trkMat)
        m.receiveShadow = true
        m.position.set(Math.cos(mid)*R, 0, Math.sin(mid)*R); m.rotation.y = -mid; g.add(m)
    }
    return g
}
function mkCheckerMat(w, l) {
    const cv = document.createElement('canvas'); cv.width = cv.height = 256
    const ctx = cv.getContext('2d')
    for (let r = 0; r < 8; r++) for (let c = 0; c < 8; c++) {
        ctx.fillStyle = (r+c) % 2 === 0 ? '#ffffff' : '#111111'
        ctx.fillRect(c*32, r*32, 32, 32)
    }
    const tex = new THREE.CanvasTexture(cv)
    tex.wrapS = tex.wrapT = THREE.RepeatWrapping; tex.repeat.set(w/10, l/10)
    return new THREE.MeshStandardMaterial({ map: tex, roughness: 0.6 })
}
function addToTrack(obj, x, y, z) {
    obj.position.set(x, y, z); scene.add(obj)
    if (obj.isGroup) obj.traverse(c => { if (c.isMesh) { c.castShadow = true; trackPieces.push(c) } })
    else { obj.castShadow = true; trackPieces.push(obj) }
    return obj
}
function addSpinner(x, y, z, spd, aLen = 40) {
    const g = new THREE.Group(); g.position.set(x, y+3, z)
    const base = new THREE.Mesh(new THREE.CylinderGeometry(2.5, 3.5, 4, 14),
        new THREE.MeshStandardMaterial({ color: 0x333355, roughness: 0.8 }))
    base.castShadow = true; g.add(base)
    const ag = new THREE.CylinderGeometry(2.2, 2.2, aLen, 10); ag.rotateZ(Math.PI/2)
    const arm = new THREE.Mesh(ag, new THREE.MeshStandardMaterial({ color: 0xff22aa, roughness: 0.4 }))
    arm.position.y = 3; arm.castShadow = true; g.add(arm)
    scene.add(g); spinnerList.push({ g, arm, spd, aLen, aR: 2.5 })
}
function addBarricade(x, y, z, w) {
    const m = new THREE.Mesh(new THREE.BoxGeometry(w, 6, 4),
        new THREE.MeshStandardMaterial({ color: 0xffaa00, roughness: 0.7 }))
    m.position.set(x, y+3, z); m.castShadow = true; scene.add(m); staticObstacles.push(m)
}

async function buildTrack(selectedMapId) {
    mapTickCallback = null
    const api = {
        THREE, scene, addToTrack, mkStraight, mkRing, mkCheckerMat,
        addSpinner, addBarricade, TRACK_H, HOFF, startMat, trkMat,
        spinnerList, trackPieces, staticObstacles, getAllPlayers: () => allPlayers,
        setFinishLineZ: (z) => finishLineZ = z,
        gameRunningRef: () => gameRunning,
        registerTick: (fn) => { mapTickCallback = fn }
    }
    if (selectedMapId === 'map2') {
        const { default: buildMap } = await import('./map2.js')
        buildMap(api)
    } else {
        const { default: buildMap } = await import('./map1.js')
        buildMap(api)
    }
    const wall = new THREE.Mesh(new THREE.BoxGeometry(200, 30, 4),
        new THREE.MeshStandardMaterial({ visible:false, transparent:true, opacity:0 }))
    wall.position.set(0, 0, finishLineZ-6); scene.add(wall); staticObstacles.push(wall)
}

// ── PLAYER MESH CREATION ───────────────────────────────────────────────────
function mkPlayer(ch, name, isUser, spawnPos) {
    const g = new THREE.Group(); scene.add(g)
    const body = new THREE.Group(); body.position.y = 0.6; g.add(body)
    const mat = new THREE.MeshStandardMaterial({ color: ch.color, roughness: 0.45, metalness: 0.1 })
    let shapeMesh

    if (ch.hex === '#ff3333') {
        shapeMesh = new THREE.Mesh(new THREE.SphereGeometry(2,16,16), mat)
        shapeMesh.scale.set(1.1,1.2,1); shapeMesh.position.y = 0.5
        const m = new THREE.Mesh(new THREE.TorusGeometry(0.3,0.1,8,16,Math.PI), new THREE.MeshStandardMaterial({color:0x111111}))
        m.rotation.z = Math.PI; m.position.set(0,-0.2,-1.9); shapeMesh.add(m)
    } else if (ch.hex === '#ffdd00') {
        shapeMesh = new THREE.Mesh(new THREE.CylinderGeometry(0.6,0.6,4,16), mat)
        const pa = shapeMesh.geometry.attributes.position
        for (let i=0;i<pa.count;i++){const y=pa.getY(i),z=pa.getZ(i);pa.setZ(i,z-Math.sin((y/2)*Math.PI)*1.5)}
        shapeMesh.geometry.computeVertexNormals(); shapeMesh.position.y = 1.0
        const m = new THREE.Mesh(new THREE.TorusGeometry(0.3,0.1,8,16,Math.PI), new THREE.MeshStandardMaterial({color:0x111111}))
        m.rotation.z = Math.PI; m.position.set(0,0.5,-2.1); shapeMesh.add(m)
    } else if (ch.hex === '#00ccff') {
        shapeMesh = new THREE.Mesh(new THREE.BoxGeometry(3.5,3.5,3.5), mat)
        mat.transparent=true; mat.opacity=0.8; mat.roughness=0.1
        const m = new THREE.Mesh(new THREE.BoxGeometry(1.2,0.2,0.2), new THREE.MeshStandardMaterial({color:0x111111}))
        m.position.set(0,-0.6,-1.8); shapeMesh.add(m)
    } else if (ch.hex === '#ff9900') {
        shapeMesh = new THREE.Mesh(new THREE.SphereGeometry(2.2,16,16), mat); shapeMesh.position.y = 0.5
        const m = new THREE.Mesh(new THREE.BoxGeometry(2.8,0.7,0.2), new THREE.MeshStandardMaterial({color:0x111111}))
        m.position.set(0,0.5,-2.1); shapeMesh.add(m)
    } else if (ch.hex === '#44ff44') {
        shapeMesh = new THREE.Mesh(new THREE.CylinderGeometry(1.2,1.2,2.5,16), mat)
        const cT=new THREE.Mesh(new THREE.SphereGeometry(1.2,16,16,0,Math.PI*2,0,Math.PI/2),mat); cT.position.y=1.25
        const cB=new THREE.Mesh(new THREE.SphereGeometry(1.2,16,16,0,Math.PI*2,Math.PI/2,Math.PI/2),mat); cB.position.y=-1.25
        shapeMesh.add(cT,cB); shapeMesh.position.y=1.0
        const m=new THREE.Mesh(new THREE.TorusGeometry(0.5,0.15,8,16,Math.PI),new THREE.MeshStandardMaterial({color:0x111111}))
        m.rotation.z=Math.PI; m.position.set(0,-0.2,-1.25); shapeMesh.add(m)
    } else if (ch.hex === '#dd44ff') {
        shapeMesh = new THREE.Mesh(new THREE.SphereGeometry(1.8,16,16), mat)
        shapeMesh.scale.set(1.0,1.3,1.0); shapeMesh.position.y=0.8
        const fM=new THREE.MeshStandardMaterial({color:0x111111})
        const m=new THREE.Mesh(new THREE.TorusGeometry(0.3,0.1,8,16,Math.PI),fM)
        m.position.set(0,-0.4,-1.8); shapeMesh.add(m)
        const bG=new THREE.BoxGeometry(0.7,0.15,0.25)
        const bL=new THREE.Mesh(bG,fM); bL.position.set(-0.55,0.45,-1.75); bL.rotation.z=-Math.PI/6; shapeMesh.add(bL)
        const bR=new THREE.Mesh(bG,fM); bR.position.set(0.55,0.45,-1.75);  bR.rotation.z= Math.PI/6; shapeMesh.add(bR)
    } else {
        shapeMesh = new THREE.Mesh(new THREE.BoxGeometry(3.5,3.5,3.5), mat)
    }
    shapeMesh.castShadow=true; body.add(shapeMesh)

    const eG=new THREE.SphereGeometry(0.3,8,8)
    const eM=new THREE.MeshStandardMaterial({color:0xffffff})
    const pM=new THREE.MeshStandardMaterial({color:0x111111})
    if (ch.hex !== '#ff9900') {
        for (const sx of [-0.6,0.6]) {
            const eye=new THREE.Mesh(eG,eM)
            if      (ch.hex==='#ff3333') eye.position.set(sx,0.6,-1.8)
            else if (ch.hex==='#ffdd00') eye.position.set(sx,1.1,-2.1)
            else if (ch.hex==='#00ccff') eye.position.set(sx,0.4,-1.8)
            else if (ch.hex==='#44ff44') eye.position.set(sx,0.8,-1.15)
            else if (ch.hex==='#dd44ff') eye.position.set(sx,1.1,-1.75)
            else                         eye.position.set(sx,0.4,-1.85)
            body.add(eye)
            const pupil=new THREE.Mesh(new THREE.SphereGeometry(0.15,6,6),pM)
            pupil.position.z=-0.2; eye.add(pupil)
        }
    }
    const deck=new THREE.Mesh(new THREE.BoxGeometry(4.3,0.4,5.0),new THREE.MeshStandardMaterial({color:0xddbb77,roughness:0.6}))
    deck.castShadow=true; deck.position.y=-1.98; g.add(deck)
    const wG=new THREE.CylinderGeometry(0.52,0.52,0.4,10); wG.rotateZ(Math.PI/2)
    const wM=new THREE.MeshStandardMaterial({color:0x222222}); const wheels=[]
    for (const [wx,wz] of [[-1.6,-1.7],[-1.6,1.7],[1.6,-1.7],[1.6,1.7]]) {
        const w=new THREE.Mesh(wG,wM); w.position.set(wx,-2.38,wz); w.castShadow=true; g.add(w); wheels.push(w)
    }
    const tag=new THREE.Mesh(new THREE.SphereGeometry(0.55,8,8),
        new THREE.MeshStandardMaterial({color:ch.color,emissive:ch.color,emissiveIntensity:0.5}))
    tag.position.y=3.4; g.add(tag)
    g.position.copy(spawnPos)
    return { g, wheels, name, isUser, finished:false, finishRank:0, colorHex:ch.color, hex:ch.hex,
             halfH:3.5, vel:new THREE.Vector3(), onGround:false, jumpCD:0, fallen:0,
             targetSpeed: isUser ? 0 : 20+Math.random()*8, steerX:0, botJumpCD:0 }
}

function mkRemotePlayerMesh(hex) {
    const colorNum = parseInt(hex.replace('#',''), 16)
    const g = new THREE.Group(); scene.add(g)
    const mat = new THREE.MeshStandardMaterial({ color: colorNum, roughness: 0.5, transparent: true, opacity: 0.85 })
    const body = new THREE.Mesh(new THREE.SphereGeometry(2.2, 12, 12), mat)
    body.position.y = 0.6; body.castShadow = true; g.add(body)
    const deck=new THREE.Mesh(new THREE.BoxGeometry(4.3,0.4,5.0),new THREE.MeshStandardMaterial({color:0xddbb77,roughness:0.6,transparent:true,opacity:0.85}))
    deck.position.y=-1.98; g.add(deck)
    const wG=new THREE.CylinderGeometry(0.52,0.52,0.4,10); wG.rotateZ(Math.PI/2)
    const wM=new THREE.MeshStandardMaterial({color:0x222222})
    for (const [wx,wz] of [[-1.6,-1.7],[-1.6,1.7],[1.6,-1.7],[1.6,1.7]]) {
        const w=new THREE.Mesh(wG,wM); w.position.set(wx,-2.38,wz); g.add(w)
    }
    const tag=new THREE.Mesh(new THREE.SphereGeometry(0.55,8,8),
        new THREE.MeshStandardMaterial({color:colorNum,emissive:colorNum,emissiveIntensity:0.8}))
    tag.position.y=3.8; g.add(tag)
    const nameCv = document.createElement('canvas'); nameCv.width=256; nameCv.height=64
    const nCtx = nameCv.getContext('2d')
    nCtx.fillStyle=`#${hex.replace('#','')}`; nCtx.font='bold 32px Fredoka One, sans-serif'
    nCtx.textAlign='center'; nCtx.fillText('...', 128, 46)
    const nameTex = new THREE.CanvasTexture(nameCv)
    const nameSprite = new THREE.Mesh(
        new THREE.PlaneGeometry(8, 2),
        new THREE.MeshBasicMaterial({ map: nameTex, transparent: true, depthTest: false, side: THREE.DoubleSide })
    )
    nameSprite.position.y = 5.5; g.add(nameSprite)
    g.position.set(0, 200, 0)
    return { g, nameTex, nameCv, nCtx, nameSprite, hex, colorNum }
}

function updateRemoteNameTag(remote, name) {
    const { nCtx, nameCv, nameTex } = remote
    nCtx.clearRect(0,0,256,64); nCtx.fillStyle=remote.hex
    nCtx.font='bold 28px sans-serif'; nCtx.textAlign='center'
    nCtx.shadowColor='rgba(0,0,0,0.8)'; nCtx.shadowBlur=8
    nCtx.fillText(name, 128, 46); nameTex.needsUpdate=true
}

function updateRemotePlayerColor(id, hex) {
    const rp = remotePlayers[id]; if (!rp) return
    rp.hex=hex; rp.mesh.hex=hex
    const colorNum = parseInt(hex.replace('#',''), 16)
    rp.mesh.g.traverse(child => {
        if (child.isMesh && child.material) {
            const isWheelOrDeck = child.material.color.getHex()===0x222222||child.material.color.getHex()===0xddbb77
            if (!isWheelOrDeck) child.material.color.setHex(colorNum)
        }
    })
    updateRemoteNameTag(rp.mesh, rp.name)
}

function spawnAllPlayers(cIdx, pName, numBots, mode) {
    const ch=CHARS[cIdx], base=new THREE.Vector3(0,10,-20)
    let spawnOffset = new THREE.Vector3(0,0,0)
    if (mode==='multi') {
        const myIndex = roomPlayers.findIndex(p => p.id === myPlayerId)
        spawnOffset = new THREE.Vector3((myIndex-Math.floor(roomPlayers.length/2))*10, 0, -(myIndex*4))
    }
    userPlayer=mkPlayer(ch, pName, true, base.clone().add(spawnOffset)); allPlayers=[userPlayer]
    if (mode==='single') {
        const botChars=CHARS.filter((_,i)=>i!==cIdx)
        const botNames=['StrawQ','Ybanana','Ecoistic','IcyFizz']
        for (let i=0;i<numBots;i++) {
            const bc=botChars[i%botChars.length]
            allPlayers.push(mkPlayer(bc, botNames[i], false, base.clone().add(new THREE.Vector3((i-1.5)*14,0,-(i+1)*5))))
        }
    } else {
        remotePlayers={}
        for (const rp of roomPlayers) {
            if (rp.id===myPlayerId) continue
            const chosenHex=(charSelections[rp.id]&&charSelections[rp.id].hex)||rp.hex
            const chosenName=(charSelections[rp.id]&&charSelections[rp.id].name)||rp.name
            const remote=mkRemotePlayerMesh(chosenHex)
            updateRemoteNameTag(remote, chosenName)
            remotePlayers[rp.id]={ mesh:remote, name:chosenName, hex:chosenHex,
                                    pos:new THREE.Vector3(0,200,0), rot:new THREE.Euler(),
                                    finished:false, finishRank:0 }
        }
    }
}

function onRemotePlayerState(payload) {
    if (!gameRunning) return
    const { id, name, hex, x, y, z, rx, ry, rz, finished, finishRank } = payload
    if (!remotePlayers[id]) {
        const remote=mkRemotePlayerMesh(hex||'#ff3333')
        updateRemoteNameTag(remote, name||'Player')
        remotePlayers[id]={ mesh:remote, name:name||'Player', hex:hex||'#ff3333',
                             pos:new THREE.Vector3(x,y,z), rot:new THREE.Euler(rx,ry,rz),
                             finished:false, finishRank:0 }
    }
    const rp=remotePlayers[id]
    rp.pos.set(x,y,z); rp.rot.set(rx,ry,rz); rp.name=name; rp.disconnected=false
    remoteLastSeen[id]=performance.now()
    if (finished&&!rp.finished) {
        rp.finished=true; rp.finishRank=finishRank
        finishResults.push({ name, rank:finishRank, isUser:false, hex:hex||rp.hex })
        finishResults.sort((a,b)=>a.rank-b.rank)
    }
}

function lerpRemotePlayers(dt) {
    const now=performance.now(); let allRemoteGone=true
    for (const id in remotePlayers) {
        const rp=remotePlayers[id], mesh=rp.mesh.g
        if (!rp.finished&&remoteLastSeen[id]&&(now-remoteLastSeen[id])>DISCONNECT_TIMEOUT) {
            if (!rp.disconnected) rp.disconnected=true
        }
        if (!rp.disconnected&&!rp.finished) allRemoteGone=false
        mesh.position.lerp(rp.pos, Math.min(1, dt*18))
        mesh.rotation.x=THREE.MathUtils.lerp(mesh.rotation.x, rp.rot.x, 0.3)
        mesh.rotation.y=THREE.MathUtils.lerp(mesh.rotation.y, rp.rot.y, 0.3)
        mesh.rotation.z=THREE.MathUtils.lerp(mesh.rotation.z, rp.rot.z, 0.3)
        if (rp.mesh.nameSprite&&camera) rp.mesh.nameSprite.lookAt(camera.position)
    }
    if (!raceOver&&userPlayer&&!userPlayer.finished&&Object.keys(remotePlayers).length>0&&allRemoteGone) {
        raceOver=true; userPlayer.finished=true; finishedCount++; userPlayer.finishRank=1
        finishResults.unshift({ name:playerNameStr, rank:1, isUser:true, hex:CHARS[selectedChar]?.hex||'#ff3333' })
        setTimeout(showPodium, 1200)
    }
}

// ── GAME TICK ──────────────────────────────────────────────────────────────
function gameTick() {
    if (!gameRunning) return
    animId=requestAnimationFrame(gameTick)
    if (gamePaused) return
    const dt=Math.min(clock.getDelta(), 0.05)
    for (const sp of spinnerList) {
        if (!sp.isCannon) sp.g.rotation.y += sp.spd + 0.08
    }
    for (const p of allPlayers) if (!p.finished) updatePlayer(p,dt)
    playerPlayerCollide()

    if (mapTickCallback) mapTickCallback(dt)

    if (currentMode==='multi') {
        lerpRemotePlayers(dt)
        const now=performance.now()
        if (now-lastBroadcast>BROADCAST_INTERVAL&&userPlayer) {
            lastBroadcast=now
            const up=userPlayer
            broadcastMyState({
                id:myPlayerId, name:playerNameStr, hex:CHARS[selectedChar]?.hex||'#ff3333',
                x:up.g.position.x, y:up.g.position.y, z:up.g.position.z,
                rx:up.g.rotation.x, ry:up.g.rotation.y, rz:up.g.rotation.z,
                finished:up.finished, finishRank:up.finishRank
            })
        }
    }

    // Camera: decoupled Y lerp
    const CAM_XZ_LERP = 0.1
    const CAM_Y_LERP  = 0.08
    const targetPos = userPlayer.g.position.clone().add(new THREE.Vector3(0, 17, 30))
    if (smoothCamY === null || Math.abs(targetPos.y - smoothCamY) > 50) smoothCamY = targetPos.y
    smoothCamY += (targetPos.y - smoothCamY) * CAM_Y_LERP
    camera.position.x += (targetPos.x - camera.position.x) * CAM_XZ_LERP
    camera.position.z += (targetPos.z - camera.position.z) * CAM_XZ_LERP
    camera.position.y  = smoothCamY
    camera.lookAt(userPlayer.g.position.clone().add(new THREE.Vector3(0, 2, 0)))

    updateHUD(); renderer.render(scene, camera)
}

function updatePlayer(p,dt) {
    if (p.fallen>0){
        p.fallen-=dt
        if (p.fallen<=0 && p.isUser) playRespawn()
    }else{if(p.isUser)handleUser(p,dt);else handleBot(p,dt)}
    p.vel.y-=GRAVITY*dt
    p.g.position.x+=p.vel.x*dt; p.g.position.y+=p.vel.y*dt; p.g.position.z+=p.vel.z*dt
    const brk=p.isUser&&(keys['ShiftLeft']||keys['ShiftRight']||joy.braking)
    const fX=Math.pow(brk?BRAKE_F:SLIDE_X,dt*60)
    const fZ=Math.pow(brk?BRAKE_F:ROLL_Z, dt*60)
    const fA=Math.pow(AIR_D,dt*60)
    if (p.onGround){p.vel.x*=fX;p.vel.z*=fZ}else{p.vel.x*=fA;p.vel.z*=fA}
    p.onGround=false; groundCheck(p); collideSpinners(p); collideStatics(p)
    if (p.jumpCD>0) p.jumpCD-=dt; if (p.botJumpCD>0) p.botJumpCD-=dt
    if (p.fallen>0){
        p.g.rotation.z=THREE.MathUtils.lerp(p.g.rotation.z,0,0.18)
        p.g.rotation.x=THREE.MathUtils.lerp(p.g.rotation.x,-Math.PI/2.2,0.15)
    }else{
        p.g.rotation.z=THREE.MathUtils.lerp(p.g.rotation.z,-p.vel.x*0.012,0.18)
        p.g.rotation.x=THREE.MathUtils.lerp(p.g.rotation.x, p.vel.z*0.006,0.12)
    }
    const spd2=Math.sqrt(p.vel.x**2+p.vel.z**2)
    if (spd2>0.8) p.g.rotation.y=THREE.MathUtils.lerp(p.g.rotation.y,Math.atan2(p.vel.x,p.vel.z),0.14)
    p.wheels.forEach(w=>{w.rotation.y+=spd2*dt*0.7})

    if (p.isUser){
        // ── Speed bar ──
        document.getElementById('hudSpeedBar').style.width=(Math.min(spd2/32,1)*100)+'%'
        document.getElementById('hudBrake').style.display=brk?'block':'none'

        // ── Skate SFX: play while moving on ground, pause otherwise ──
        const skateSfx = document.getElementById('skateSfx')
        if (skateSfx) {
            if (p.onGround && spd2 > 2 && p.fallen <= 0 && !gamePaused) {
                if (skateSfx.paused) {
                    skateSfx.volume = Math.min(1, spd2 / 20)
                    try { skateSfx.play().catch(() => {}) } catch(e) {}
                } else {
                    // Smoothly adjust volume with speed
                    skateSfx.volume = Math.min(1, spd2 / 20)
                }
            } else {
                if (!skateSfx.paused) skateSfx.pause()
            }
        }
    }

    // ── Fall / out of bounds respawn ──
    if (p.g.position.y < -55){
        p.g.position.set((Math.random()-.5)*30, 10, -20)
        p.vel.set(0,0,0)
        if (p.isUser) playRespawn()
    }

    // ── Finish line check ──
    if (!p.finished && p.g.position.z < finishLineZ){
        p.finished=true; finishedCount++; p.finishRank=finishedCount
        finishResults.push({name:p.name, rank:finishedCount, isUser:p.isUser, hex:p.hex})
        if (p.isUser && !raceOver) {
            broadcastMyState({
                id:myPlayerId, name:playerNameStr, hex:CHARS[selectedChar]?.hex||'#ff3333',
                x:p.g.position.x, y:p.g.position.y, z:p.g.position.z,
                rx:p.g.rotation.x, ry:p.g.rotation.y, rz:p.g.rotation.z,
                finished:true, finishRank:finishedCount
            })
            // Stop skate sfx when crossing finish
            const skateSfx = document.getElementById('skateSfx')
            if (skateSfx) skateSfx.pause()
        }
        if (!raceOver) checkRaceOver()
    }
}

function checkRaceOver() {
    if (currentMode==='single') {
        if (finishedCount>=1) {
            [...allPlayers].filter(p=>!p.finished).sort((a,b)=>a.g.position.z-b.g.position.z).forEach(p=>{
                finishedCount++;p.finished=true;p.finishRank=finishedCount
                finishResults.push({name:p.name,rank:finishedCount,isUser:p.isUser,hex:p.hex})
            })
            raceOver=true; setTimeout(showPodium,1400)
        }
    } else {
        if (userPlayer.finished) { raceOver=true; setTimeout(showPodium,2000) }
    }
}

function handleUser(p,dt){
    const SPD=220,TURN=140,JUMP=20,MAX=45
    const fwd=keys['KeyW']||keys['ArrowUp']   ||joy.y<-0.25
    const bck=keys['KeyS']||keys['ArrowDown'] ||joy.y> 0.25
    const lft=keys['KeyA']||keys['ArrowLeft'] ||joy.x<-0.25
    const rgt=keys['KeyD']||keys['ArrowRight']||joy.x> 0.25
    const jmp=keys['Space']||joy.jumping
    if (fwd) p.vel.z-=SPD*dt*(joy.active?Math.abs(joy.y)||0.6:1)
    if (bck) p.vel.z+=SPD*dt*0.5
    if (lft) p.vel.x-=TURN*dt*(joy.active?Math.abs(joy.x)||0.6:1)
    if (rgt) p.vel.x+=TURN*dt*(joy.active?Math.abs(joy.x)||0.6:1)
    p.vel.x=THREE.MathUtils.clamp(p.vel.x,-MAX,MAX)
    p.vel.z=THREE.MathUtils.clamp(p.vel.z,-MAX*1.3,MAX*0.5)
    if (jmp&&p.onGround&&p.jumpCD<=0){p.vel.y=JUMP;p.onGround=false;p.jumpCD=0.28}
}

function handleBot(p,dt){
    p.vel.z=THREE.MathUtils.lerp(p.vel.z,-p.targetSpeed,dt*2.8); p.vel.x*=0.91
    const origin=p.g.position.clone(); origin.y+=1.5; const LOOK=26
    const allObs=[...spinnerList.map(s=>s.arm),...staticObstacles,...allPlayers.filter(op=>op!==p&&!op.finished).map(op=>op.g)]
    let steer=0
    for (const [dx,dz,side] of [[0,-1,0],[0.65,-1,-1],[-0.65,-1,1]]){
        const dir=new THREE.Vector3(dx,0,dz).normalize()
        const hits=new THREE.Raycaster(origin,dir,0,LOOK).intersectObjects(allObs,false)
        if (hits.length){
            const d=hits[0].distance
            if (side===0){if(d<15&&p.onGround&&p.botJumpCD<=0){p.vel.y=43;p.botJumpCD=0.55;p.onGround=false}steer+=(Math.random()>.5?1:-1)*(LOOK-d)*0.55}
            else steer+=side*(LOOK-d)*0.5
        }
    }
    if (p.onGround&&p.botJumpCD<=0){
        const fw=p.g.position.clone(); fw.z+=p.vel.z*0.32; fw.x+=p.vel.x*0.32; fw.y+=2
        if (!new THREE.Raycaster(fw,new THREE.Vector3(0,-1,0),0,14).intersectObjects(trackPieces,false).length){p.vel.y=43;p.botJumpCD=0.55;p.onGround=false}
    }
    if (!new THREE.Raycaster(origin,new THREE.Vector3( 1,-0.35,0),0,18).intersectObjects(trackPieces,false).length) steer-=10
    if (!new THREE.Raycaster(origin,new THREE.Vector3(-1,-0.35,0),0,18).intersectObjects(trackPieces,false).length) steer+=10
    p.steerX=THREE.MathUtils.lerp(p.steerX,steer*2.8,dt*4.5); p.vel.x+=p.steerX*dt
    p.vel.x=THREE.MathUtils.clamp(p.vel.x,-20,20)
}

const _dDir=new THREE.Vector3(0,-1,0),_iMat=new THREE.Matrix4(),_tVec=new THREE.Vector3(),_box3=new THREE.Box3()

let lastRespawnTime = 0
function playRespawn() {
    const now = performance.now()
    if (now - lastRespawnTime > 1200) {
        lastRespawnTime = now
        const sfx = document.getElementById('respawnSfx')
        if (sfx) {
            sfx.currentTime = 0
            try { sfx.play().catch(() => {}) } catch(e) {}
        }
    }
}

function groundCheck(p){
    const hits=new THREE.Raycaster(p.g.position,_dDir,0,p.halfH+1.8).intersectObjects(trackPieces,false)
    if (hits.length&&hits[0].object.visible&&p.vel.y<=0.1){
        const sy=hits[0].point.y+p.halfH; if (p.g.position.y-sy<2){p.g.position.y=sy;p.vel.y=0;p.onGround=true}
    }
}

let lastCollisionTime = 0
function playCollision() {
    const now = performance.now()
    if (now - lastCollisionTime > 250) {
        lastCollisionTime = now
        const sfx = document.getElementById('collisionSfx')
        if (sfx) {
            sfx.currentTime = 0
            try { sfx.play().catch(() => {}) } catch(e) {}
        }
    }
}

function collideSpinners(p){
    for (const sp of spinnerList){
        if (sp.isCannon) continue   // cannons handled in map2 tick
        _iMat.copy(sp.arm.matrixWorld).invert()
        const loc=p.g.position.clone().applyMatrix4(_iMat)
        const da=Math.sqrt(loc.y*loc.y+loc.z*loc.z)
        if (Math.abs(loc.x)<sp.aLen/2+PLAYER_R&&da<sp.aR+PLAYER_R){
            const pen=(sp.aR+PLAYER_R)-da; _tVec.set(0,loc.y,loc.z)
            if (_tVec.lengthSq()<0.001) _tVec.set(0,1,0)
            _tVec.normalize().transformDirection(sp.arm.matrixWorld).normalize()
            p.g.position.addScaledVector(_tVec,pen+0.25)
            p.vel.x=_tVec.x*22;p.vel.z=_tVec.z*22;p.vel.y=8;p.onGround=false
            if (p.fallen<=0) p.fallen=1.5
            if (p.isUser) playCollision()
        }
    }
}
function collideStatics(p){
    for (const obs of [...staticObstacles,...trackPieces]){
        _box3.setFromObject(obs)
        const cl=p.g.position.clone().clamp(_box3.min,_box3.max)
        const diff=p.g.position.clone().sub(cl); const dist=diff.length()
        if (dist<PLAYER_R){
            if (p.isUser) playCollision()
            const pen=PLAYER_R-dist; const dir=dist>0.001?diff.normalize():new THREE.Vector3(0,1,0)
            p.g.position.addScaledVector(dir,pen+0.1)
            if (dir.y<0.5){p.vel.x*=0.25;p.vel.z*=0.25} if (dir.y>0.5&&p.vel.y<0) p.vel.y=0
        }
    }
}

// ── PLAYER-PLAYER COLLISION ────────────────────────────────────────────────
function playerPlayerCollide() {
    const D = 4.2
    for (let i = 0; i < allPlayers.length; i++) {
        for (let j = i + 1; j < allPlayers.length; j++) {
            const a = allPlayers[i], b = allPlayers[j]
            if (a.finished || b.finished) continue
            const diff = a.g.position.clone().sub(b.g.position)
            diff.y = 0
            const dist = diff.length()
            if (dist < D && dist > 0.001) {
                if (a.isUser || b.isUser) playCollision()
                const pen  = (D - dist) / 2
                const push = diff.normalize().multiplyScalar(pen + 0.1)
                a.g.position.add(push)
                a.vel.x = push.x * 12; a.vel.z = push.z * 12; a.vel.y = -5; a.onGround = false
                b.g.position.sub(push)
                b.vel.x = -push.x * 12; b.vel.z = -push.z * 12; b.vel.y = -5; b.onGround = false
            }
        }
    }
    if (currentMode === 'multi' && userPlayer && !userPlayer.finished) {
        for (const id in remotePlayers) {
            const rp = remotePlayers[id]
            if (rp.finished || rp.disconnected) continue
            const diff = userPlayer.g.position.clone().sub(rp.mesh.g.position)
            diff.y = 0
            const dist = diff.length()
            if (dist < D && dist > 0.001) {
                playCollision()
                const pen  = D - dist
                const push = diff.normalize().multiplyScalar(pen * 0.6 + 0.1)
                userPlayer.g.position.add(push)
                userPlayer.vel.x += push.x * 14
                userPlayer.vel.z += push.z * 14
                userPlayer.vel.y  = Math.max(userPlayer.vel.y, 4)
                userPlayer.onGround = false
            }
        }
    }
}

function updateHUD(){
    const rows=[]
    for (const p of allPlayers) rows.push({ name:p.name, z:p.g.position.z, hex:p.hex, isUser:p.isUser, finished:p.finished, disconnected:false })
    if (currentMode==='multi') {
        for (const id in remotePlayers) {
            const rp=remotePlayers[id]
            rows.push({ name:rp.name, z:rp.mesh.g.position.z, hex:rp.hex, isUser:false, finished:rp.finished, disconnected:!!rp.disconnected })
        }
    }
    rows.sort((a,b)=>{
        if (a.disconnected&&!b.disconnected) return 1
        if (!a.disconnected&&b.disconnected) return -1
        return a.z-b.z
    })
    document.getElementById('hudStandingsList').innerHTML=rows.map((p,i)=>`
        <div class="standingRow${p.disconnected?' disconnected-row':''}">
            <div class="standingDot" style="background:${p.hex};${p.disconnected?'opacity:.4':''}"></div>
            <span style="color:${p.disconnected?'rgba(255,255,255,.3)':p.isUser?'#ffcc44':'#fff'};${p.disconnected?'text-decoration:line-through':''}">
                ${p.name}${p.finished?' 🏁':''}${p.disconnected?' <span style="font-size:.65rem;color:#ff6644">disconnected</span>':''}
            </span>
            <span class="standingRank ${p.isUser?'you':''}"> #${i+1}</span>
        </div>`).join('')
}

function showPodium(){
    gameRunning=false
    // Stop skate sfx at race end
    const skateSfx = document.getElementById('skateSfx')
    if (skateSfx) skateSfx.pause()

    document.getElementById('finishOverlay').style.display='flex'
    if (currentMode==='multi') {
        for (const id in remotePlayers) {
            const rp=remotePlayers[id]
            if (!rp.finished&&!finishResults.find(r=>r.name===rp.name))
                finishResults.push({ name:rp.name, rank:99, isUser:false, hex:rp.hex })
        }
    }
    if (!finishResults.find(r=>r.isUser))
        finishResults.push({ name:playerNameStr, rank:99, isUser:true, hex:CHARS[selectedChar]?.hex||'#ff3333' })
    const sorted=[...finishResults].sort((a,b)=>a.rank-b.rank)
    sorted.forEach((r,i)=>r.rank=i+1)
    const medals=['🥇','🥈','🥉']
    const userResult=sorted.find(r=>r.isUser)
    document.getElementById('finishTitle').textContent=userResult?.rank===1?'🏆 YOU WIN!':'🏁 RACE OVER!'
    document.getElementById('finishPodium').innerHTML=sorted.map((r,i)=>`
        <div class="podiumRow r${i+1}" style="animation-delay:${i*0.12}s">
            <div class="podiumMedal">${medals[i]||'#'+(i+1)}</div>
            <div class="podiumDot" style="background:${r.hex}"></div>
            <div class="podiumName">${r.name}</div>
            ${r.isUser?'<span class="podiumYou">YOU</span>':''}
        </div>`).join('')
}

// ── START GAME ─────────────────────────────────────────────────────────────
async function startGame(cIdx, pName, numBots, mode, selectedMapId) {
    const isMobile = window.matchMedia('(pointer:coarse)').matches || window.innerWidth <= 768

    gameRunning=true; gamePaused=false; raceOver=false; finishedCount=0; finishResults=[]
    trackPieces=[]; spinnerList=[]; staticObstacles=[]; allPlayers=[]; userPlayer=null
    remotePlayers={}
    smoothCamY = null

    scene=new THREE.Scene(); scene.background=new THREE.Color(0x87ceeb); scene.fog=new THREE.FogExp2(0x87ceeb,.0035)
    camera=new THREE.PerspectiveCamera(70,window.innerWidth/window.innerHeight,.1,3500); scene.add(camera)
    renderer=new THREE.WebGLRenderer({canvas, antialias:!isMobile, powerPreference:'high-performance'})
    renderer.setSize(window.innerWidth,window.innerHeight)
    renderer.setPixelRatio(isMobile ? Math.min(devicePixelRatio, 1.5) : Math.min(devicePixelRatio, 2))
    renderer.shadowMap.enabled=true; renderer.shadowMap.type=THREE.PCFSoftShadowMap
    window.addEventListener('resize',onResize)
    scene.add(new THREE.AmbientLight(0xffffff,.75))
    const dir=new THREE.DirectionalLight(0xffffff,.9); dir.position.set(80,150,80); dir.castShadow=true
    dir.shadow.camera.top=dir.shadow.camera.right=600; dir.shadow.camera.bottom=dir.shadow.camera.left=-600
    dir.shadow.camera.far=2000; dir.shadow.mapSize.set(2048,2048); scene.add(dir)
    clock=new THREE.Clock()
    trkMat=new THREE.MeshStandardMaterial({color:0x44aaee,roughness:.72,metalness:.05})
    startMat=new THREE.MeshStandardMaterial({color:0x22ee66,roughness:.72})

    await buildTrack(selectedMapId)
    spawnAllPlayers(cIdx, pName, numBots, mode)
    setupMobile()

    if (mode==='multi'&&roomCode&&myPlayerId) startGameSync(roomCode, myPlayerId, onRemotePlayerState)

    // Init chat — only shows in multiplayer
    initChat(mode)

    // Render one frame first so there's no black flash when canvas appears
    renderer.render(scene, camera)

    // NOW cross-fade to game music (after first frame is ready)
    switchToGameMusic()

    canvas.style.display = 'block'
    canvas.style.zIndex = '1000'
    document.getElementById('hud').style.display = 'flex'
    if (isMobile) {
        document.getElementById('mobileControls').style.display = 'block'
        document.getElementById('hudControls').style.display    = 'none'
    }

    gameTick()
}

function onResize(){
    if (!camera||!renderer) return
    camera.aspect=window.innerWidth/window.innerHeight; camera.updateProjectionMatrix()
    renderer.setSize(window.innerWidth,window.innerHeight)
}

function cleanupGame(){
    gameRunning=false; mapTickCallback=null
    hideChatUI()
    // Stop all SFX
    const skateSfx = document.getElementById('skateSfx')
    if (skateSfx) skateSfx.pause()
    if (animId){cancelAnimationFrame(animId);animId=null}
    if (renderer){renderer.dispose();renderer=null}
    scene=camera=clock=null; trackPieces=[];spinnerList=[];staticObstacles=[];allPlayers=[];userPlayer=null
    remotePlayers={}
    Object.keys(remoteLastSeen).forEach(k=>delete remoteLastSeen[k])
    window.removeEventListener('resize',onResize)
    stopGameSync()
}

// ── CHAT SYSTEM ────────────────────────────────────────────────────────────
let chatOpen = false

function initChat(mode) {
    const btn      = document.getElementById('chatToggleBtn')
    const overlay  = document.getElementById('chatOverlay')
    const closeBtn = document.getElementById('chatClose')
    const sendBtn  = document.getElementById('chatSend')
    const input    = document.getElementById('chatInput')
    const messages = document.getElementById('chatMessages')

    if (!btn || !overlay) return

    // Reset state
    if (messages) messages.innerHTML = ''
    overlay.style.display = 'none'
    chatOpen = false

    // Always hide button first; show only in multiplayer
    btn.style.display = 'none'

    if (mode !== 'multi') return

    // Multiplayer: show chat button
    btn.style.display = 'flex'
    btn.textContent = '💬 Chat'
    btn.classList.remove('has-new')
    appendChatMsg('system', null, '💬 Chat connected — say hi!')

    // Remove old listeners by cloning
    const newBtn = btn.cloneNode(true)
    btn.parentNode.replaceChild(newBtn, btn)

    newBtn.style.display = 'flex'
    newBtn.onclick = () => {
        chatOpen = !chatOpen
        overlay.style.display = chatOpen ? 'flex' : 'none'
        newBtn.classList.remove('has-new')
        newBtn.textContent = '💬 Chat'
        if (chatOpen) {
            input.focus()
            scrollChatBottom()
        }
    }

    if (closeBtn) {
        closeBtn.onclick = () => {
            chatOpen = false
            overlay.style.display = 'none'
        }
    }

    const doSend = () => {
        const text = (input.value || '').trim()
        if (!text || !gameChannel) return
        gameChannel.send({
            type: 'broadcast', event: 'chat',
            payload: {
                id:   myPlayerId,
                name: playerNameStr,
                hex:  CHARS[selectedChar]?.hex || '#ff3333',
                text
            }
        })
        appendChatMsg('self', { name: playerNameStr, hex: CHARS[selectedChar]?.hex || '#ff3333' }, text)
        input.value = ''
    }

    if (sendBtn) sendBtn.onclick = doSend
    if (input)   input.onkeydown = e => { if (e.key === 'Enter') { e.preventDefault(); doSend() } }
}

function appendChatMsg(type, sender, text) {
    const messages = document.getElementById('chatMessages')
    if (!messages) return

    const div = document.createElement('div')
    div.className = 'chatMsg' + (type === 'system' ? ' system' : type === 'self' ? ' self' : '')

    if (type === 'system') {
        div.textContent = text
    } else {
        const nameSpan = document.createElement('span')
        nameSpan.className = 'chatSender'
        nameSpan.style.color = sender.hex
        nameSpan.textContent = sender.name + ':'
        div.appendChild(nameSpan)
        div.appendChild(document.createTextNode(' ' + text))
    }

    messages.appendChild(div)
    scrollChatBottom()

    // Flash the chat button if overlay is closed
    if (!chatOpen && type !== 'system') {
        // Use the current button (might have been re-cloned)
        const currentBtn = document.getElementById('chatToggleBtn')
        if (currentBtn && currentBtn.style.display !== 'none') {
            currentBtn.classList.add('has-new')
            currentBtn.textContent = '💬 New!'
            clearTimeout(currentBtn._flashTimer)
            currentBtn._flashTimer = setTimeout(() => {
                currentBtn.classList.remove('has-new')
                currentBtn.textContent = '💬 Chat'
            }, 3000)
        }
    }
}

function scrollChatBottom() {
    const messages = document.getElementById('chatMessages')
    if (messages) messages.scrollTop = messages.scrollHeight
}

function hideChatUI() {
    const btn     = document.getElementById('chatToggleBtn')
    const overlay = document.getElementById('chatOverlay')
    if (btn)     btn.style.display     = 'none'
    if (overlay) overlay.style.display = 'none'
    chatOpen = false
}

// ── BOOT ───────────────────────────────────────────────────────────────────
;(async () => {
    await sbInit()
    showScreen('mainMenu')
    // Start menu music immediately on first user interaction (autoplay policy)
    const startMenuMusic = () => {
        const menuBgm = document.getElementById('menuMusic')
        if (menuBgm && menuBgm.paused) {
            menuBgm.loop = true
            try { menuBgm.play().catch(() => {}) } catch(e) {}
        }
        document.removeEventListener('pointerdown', startMenuMusic)
        document.removeEventListener('keydown', startMenuMusic)
    }
    document.addEventListener('pointerdown', startMenuMusic)
    document.addEventListener('keydown', startMenuMusic)
})()